import Region from "../Region";
import RegionArea from "../RegionArea";
import Phaser from 'phaser';

import * as ABCya from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { AREAS, SHAPES } from '../gameData';

export default class TruckArea extends RegionArea
{
    /**
     * @param {Region} region the owner region
     */
    constructor(parentRegion)
    {
        super(parentRegion, AREAS[parentRegion.region].TRUCK);

        this._createArea();

        this.reset();
    }

    /**
     * Reset should be called when you want to set the state to a disabled/inactive state.
     */
    reset()
    {
        super.reset();

        this.roof.setAlpha(0);
        this.backWindow.setAlpha(0);
        this.sideWindow.setAlpha(0);
        this.lincesPlate.setAlpha(0);
        this.bumper.setAlpha(0);
        this.tailgateLightLeft.setAlpha(0);
        this.tailgateLightRight.setAlpha(0);
        this.backHubcap.setAlpha(0);
        this.frontHubcap.setAlpha(0);
        this.backTire.setAlpha(0);
        this.frontTire.setAlpha(0);
    }

    /**
     * Prepare should be called before you want to prepare the state to become active.
     */
    prepare()
    {
        super.prepare();

        this.roof.disableInteractive();
        this.backWindow.disableInteractive();
        this.sideWindow.disableInteractive();
        this.lincesPlate.disableInteractive();
        this.bumper.disableInteractive();
        this.tailgateLightLeft.disableInteractive();
        this.tailgateLightRight.disableInteractive();
        this.backHubcap.disableInteractive();
        this.frontHubcap.disableInteractive();
        this.backTire.disableInteractive();
        this.frontTire.disableInteractive();
    }

    /**
     * Send all game objects to their start positions.
     */
    _sendObjectsToStartPositions()
    {
        super._sendObjectsToStartPositions();

        this.roof.setAlpha(0.000001);
        this.backWindow.setAlpha(0.000001);
        this.sideWindow.setAlpha(0.000001);
        this.lincesPlate.setAlpha(0.000001);
        this.bumper.setAlpha(0.000001);
        this.tailgateLightLeft.setAlpha(0.000001);
        this.tailgateLightRight.setAlpha(0.000001);
        this.backHubcap.setAlpha(0.000001);
        this.frontHubcap.setAlpha(0.000001);
        this.backTire.setAlpha(0.000001);
        this.frontTire.setAlpha(0.000001);
    }

    /**
     * Creates the area, by adding the overlays to the parent region and creates the area information sidebar.
     */
    _createArea()
    {
        let roofHitArea = new Phaser.Geom.Polygon(
            [
                { x: 207, y: 269 },
                { x: 0, y: 148 },
                { x: 254, y: 0 },
                { x: 461, y: 121 },
            ]);
        this.roof = ABCya.Images.addImage(627, 295, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_Roof, this.parentRegion).setInteractive(roofHitArea, Phaser.Geom.Polygon.Contains);
        this.roof.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.roof, SHAPES.RECTANGLE);
        });

        let backWindowHitArea = new Phaser.Geom.Polygon(
            [
                { x: 178, y: 170 },
                { x: 0, y: 67 },
                { x: 14, y: 0 },
                { x: 194, y: 102 },
            ]);
        this.backWindow = ABCya.Images.addImage(492, 416, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_BkWndw, this.parentRegion).setInteractive(backWindowHitArea, Phaser.Geom.Polygon.Contains);
        this.backWindow.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.backWindow, SHAPES.RECTANGLE);
        });

        let sideWindowHitArea = new Phaser.Geom.Polygon(
            [
                { x: 0, y: 138 },
                { x: 0, y: 60 },
                { x: 110, y: 0 },
                { x: 110, y: 78 },
            ]);
        this.sideWindow = ABCya.Images.addImage(724, 404, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_SdWndw, this.parentRegion).setInteractive(sideWindowHitArea, Phaser.Geom.Polygon.Contains);
        this.sideWindow.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.sideWindow, SHAPES.RECTANGLE);
        });

        let licensePlateHitArea = new Phaser.Geom.Polygon(
            [
                { x: 46, y: 55 },
                { x: 0, y: 31 },
                { x: 0, y: 0 },
                { x: 46, y: 24 },
            ]);
        this.lincesPlate = ABCya.Images.addImage(472, 516, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_LcnsePl8, this.parentRegion).setInteractive(licensePlateHitArea, Phaser.Geom.Polygon.Contains);
        this.lincesPlate.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.lincesPlate, SHAPES.RECTANGLE);
        });

        let bumperHitArea = new Phaser.Geom.Polygon(
            [
                { x: 210, y: 157 },
                { x: 0, y: 38 },
                { x: 0, y: 0 },
                { x: 210, y: 118 },
            ]);
        this.bumper = ABCya.Images.addImage(482, 551, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_Bmpr, this.parentRegion).setInteractive(bumperHitArea, Phaser.Geom.Polygon.Contains);
        this.bumper.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.bumper, SHAPES.RECTANGLE);
        });

        let tailgateHitArea = new Phaser.Geom.Polygon(
            [
                { x: 42, y: 40 },
                { x: 0, y: 19 },
                { x: 0, y: 0 },
                { x: 42, y: 22 },
            ]);
        this.tailgateLightLeft = ABCya.Images.addImage(398, 446, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_TailLt, this.parentRegion).setInteractive(tailgateHitArea, Phaser.Geom.Polygon.Contains);
        this.tailgateLightLeft.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.tailgateLightLeft, SHAPES.RECTANGLE);
        });

        this.tailgateLightRight = ABCya.Images.addImage(566, 544, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_TailLt, this.parentRegion).setInteractive(tailgateHitArea, Phaser.Geom.Polygon.Contains);
        this.tailgateLightRight.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.tailgateLightRight, SHAPES.RECTANGLE);
        });

        let tireHitArea = new Phaser.Geom.Polygon(
            [
                { x: 8, y: 100 },
                { x: 1, y: 79 },
                { x: 21, y: 28 },
                { x: 55, y: 3 },
                { x: 82, y: 5 },
                { x: 92, y: 24 },
                { x: 78, y: 69 },
                { x: 35, y: 104 },
            ]);
        this.backTire = ABCya.Images.addImage(686, 576, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_Tire, this.parentRegion).setInteractive(tireHitArea, Phaser.Geom.Polygon.Contains);
        this.backTire.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.backTire, SHAPES.CIRCLE);
        });

        this.frontTire = ABCya.Images.addImage(912, 436, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_Tire, this.parentRegion).setInteractive(tireHitArea, Phaser.Geom.Polygon.Contains);
        this.frontTire.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.frontTire, SHAPES.CIRCLE);
        });

        let hubcapHitArea = new Phaser.Geom.Polygon(
            [
                { x: 8, y: 64 },
                { x: 1, y: 47 },
                { x: 12, y: 20 },
                { x: 33, y: 3 },
                { x: 52, y: 4 },
                { x: 58, y: 21 },
                { x: 47, y: 47 },
                { x: 24, y: 64 },
            ]);
        this.backHubcap = ABCya.Images.addImage(685, 575, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_Hbcap, this.parentRegion).setInteractive(hubcapHitArea, Phaser.Geom.Polygon.Contains);
        this.backHubcap.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.backHubcap, SHAPES.CIRCLE);
        });

        this.frontHubcap = ABCya.Images.addImage(912, 434, UIAssetKeys._10_Camping_Zoom_In_Truck_Slct_Hbcap, this.parentRegion).setInteractive(hubcapHitArea, Phaser.Geom.Polygon.Contains);
        this.frontHubcap.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this._onOverlayPointerDown(this.frontHubcap, SHAPES.CIRCLE);
        });

        this.shapeOverlays[SHAPES.RECTANGLE] = [this.roof, this.backWindow, this.sideWindow, this.tailgateLightLeft, this.tailgateLightRight, this.lincesPlate, this.bumper];
        this.shapeOverlays[SHAPES.CIRCLE] = [this.backHubcap, this.frontHubcap, this.backTire, this.frontTire];

        this._createAreaInformation(0x5f5fd6, 0x204243);
    }

    /**
     * Zoom into the area.
     */
    zoomIn()
    {
        let tweens = super.zoomIn();

        tweens.push(
            {
                targets: [
                    this.parentRegion.tent, this.parentRegion.treeAreaContainer, this.parentRegion.chair
                ],
                duration: 500,
                props: { alpha: 0 },
                ease: Phaser.Math.Easing.Quadratic.Out,
            },
            { targets: this.parentRegion.truck, duration: 1000, props: { scale: 1, x: 685, y: 394 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 0 },
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.onScreenPosition.x }, ease: Phaser.Math.Easing.Back.Out, offset: 500 }
        );

        return tweens;
    }

    /**
     * Zoom out of the area.
     */
    zoomOut()
    {
        let tweens = super.zoomOut();

        this.roof.disableInteractive();
        this.backWindow.disableInteractive();
        this.sideWindow.disableInteractive();
        this.lincesPlate.disableInteractive();
        this.bumper.disableInteractive();
        this.tailgateLightLeft.disableInteractive();
        this.tailgateLightRight.disableInteractive();
        this.backHubcap.disableInteractive();
        this.frontHubcap.disableInteractive();
        this.backTire.disableInteractive();
        this.frontTire.disableInteractive();

        for (let shape in this.shapeOverlays)
        {
            // fade off the overlay
            tweens.push(
                {
                    targets: this.shapeOverlays[shape],
                    duration: 500,
                    props: { alpha: 0 },
                    ease: Phaser.Math.Easing.Quadratic.Out,
                    offset: 0
                }
            );
        }

        tweens.push(
            { targets: this.areaInformation, duration: 500, props: { x: this.areaInformation.offScreenPosition.x }, ease: Phaser.Math.Easing.Back.In, offset: 0 },
            { targets: this.parentRegion.truck, duration: 1000, props: { scale: 0.4393, x: this.parentRegion.truck.onScreenPosition.x, y: this.parentRegion.truck.onScreenPosition.y }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 250 },
            { targets: [this.parentRegion.tent, this.parentRegion.treeAreaContainer, this.parentRegion.chair], duration: 500, props: { alpha: 1 }, ease: Phaser.Math.Easing.Quadratic.Out, offset: 500 },
        );

        return tweens;
    }
}